export default __webpack_public_path__ + "static/media/littleClose.3573f8be.svg";